export default function Schedule() {
  return (
    <div className="container mx-auto">
      <h1 className="text-2xl">Schedule page</h1>
    </div>
  );
}
